import { store } from '@src/state/store';
import { onCreatedGameId } from '@src/state/slices/slice_lobby';
import { onJoinedGame, setPlayerMeta } from '@src/state/slices/slice_game';
import { setStage } from '@src/state/slices/slice_app';
import { Stage } from '@src/state/slices/types';

export default () => (data: any) => {
  if (!data || !data.gameId || !data.playerId) return;
  store.dispatch(onCreatedGameId(data));
  store.dispatch(
    onJoinedGame({
      gameId: data.gameId,
      playerId: data.playerId,
      playerIndex: 0,
    }),
  );
  store.dispatch(
    setPlayerMeta({ playerId: data.playerId, playerIndex: 0, name: '' }),
  ); // TODO: fix this
  store.dispatch(
    setStage({
      stage: Stage.SHOW_GAME,
      stageMeta: { gameId: data.gameId, playerId: data.playerId },
    }),
  );
};
